import { useEffect, useState, useCallback } from 'react';
import { getUserConnection, addUserConnections } from '@alltrails/redux/slices/userConnections';
import { UserConnection } from '@alltrails/types/belay';
import addActionsToUserConnection from '../utils/addActionsToUserConnection';
import { getUserConnectionStatus } from '../utils/belayRequests';
import { useAppSelector, useAppDispatch } from '../utils/redux';

const useUserConnection = (userId?: number, otherUserId?: number) => {
  const dispatch = useAppDispatch();
  const userConnections = useAppSelector(state => state?.userConnections);
  const [userConnection, setUserConnection] = useState<UserConnection | null>(null);
  const getConnection = useCallback((id: string) => getUserConnection(userConnections, id), [userConnections]);

  useEffect(() => {
    const fetchConnections = async () => {
      // Check the UserConnections store to see if there is a userConnection already:
      const connection = otherUserId && getConnection(String(otherUserId));

      if (connection) {
        // if there is, return it (this also covers the case where something else updates the userConnection in redux):
        setUserConnection(connection);
      } else if (userId && otherUserId) {
        // if there is not, fetch it using getUserConnectionStatus:
        const connectionStatus = await getUserConnectionStatus(userId, otherUserId);
        const connectionWithActions = addActionsToUserConnection(connectionStatus);
        // Add this connection to the UserConnections store:
        dispatch(addUserConnections([connectionWithActions]));
        setUserConnection(connectionWithActions);
      }
    };

    if (userId !== otherUserId) {
      fetchConnections().catch((e: Error) => {
        console.error(e);
      });
    }
  }, [dispatch, getConnection, otherUserId, userId]);

  return userConnection;
};

export default useUserConnection;
